import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Box, ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import Navigation from './components/Navigation';
import ScrollProgress from './components/ScrollProgress';
import BackToTop from './components/BackToTop';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import FeaturesPage from './pages/FeaturesPage';
import VisionPage from './pages/VisionPage';
import TeamPage from './pages/TeamPage';
import ContactPage from './pages/ContactPage';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1a237e',
    },
    secondary: {
      main: '#ff4081',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 600,
    },
  },
});

interface AppProps {
  isTest?: boolean;
}

// Lazy load admin panel
const AdminPanel = React.lazy(() => import('./components/admin/AdminPanel'));

function App({ isTest = false }: AppProps = {}) {
  const content = (
    <Box sx={{ bgcolor: '#1a237e', minHeight: '100vh', color: 'white' }}>
      <Navigation />
      <Routes>
        {!isTest ? (
          <>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/vision" element={<VisionPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </>
        ) : (
          <Route path="/" element={<HomePage />} />
        )}
        <Route path="/admin" element={
          <React.Suspense fallback={<div>Loading...</div>}>
            <AdminPanel />
          </React.Suspense>
        } />
      </Routes>
    </Box>
  );

  return (
    <Router>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ScrollProgress />
        <BackToTop />
        {content}
      </ThemeProvider>
    </Router>
  );
}

export default App;
